import { useRightRail } from "@/context/RightRailContext";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { NotificationsPanel } from "./NotificationsPanel";
import { RightRailContent } from "./RightRail";

interface MobileWorkspaceSheetProps {
  /** Kai landing — workspace sheet is hidden; notifications-only still applies. */
  kaiPage?: boolean;
}

/** Mobile sheet for workspace widgets or notifications (never both entry points). */
export function MobileWorkspaceSheet({ kaiPage }: MobileWorkspaceSheetProps) {
  const {
    mobileRailOpen,
    mobileRailMode,
    setMobileRailOpen,
    notificationsPanelActive,
    toggleNotificationsPanel,
    pageRailMeta,
  } = useRightRail();

  const isNotifications = mobileRailMode === "notifications";

  function handleOpenChange(open: boolean) {
    if (!open && isNotifications && notificationsPanelActive) {
      toggleNotificationsPanel();
    }
    setMobileRailOpen(open);
  }

  return (
    <Sheet open={mobileRailOpen} onOpenChange={handleOpenChange}>
      <SheetContent
        side="right"
        className="w-[min(340px,85vw)] max-w-[85vw] gap-0 border-border/60 p-0"
      >
        <SheetHeader className="sticky top-0 z-10 shrink-0 border-b border-border/60 bg-card/95 px-5 py-4 pr-12 text-left backdrop-blur-sm">
          <SheetTitle>
            {isNotifications ? "Notifications" : "Workspace"}
          </SheetTitle>
        </SheetHeader>
        {isNotifications ? (
          <NotificationsPanel
            fill
            className="flex min-h-0 w-full min-w-0 max-w-full flex-1 flex-col"
          />
        ) : (
          <div className="px-5 py-4">
            <RightRailContent
              kaiPage={kaiPage}
              showNotifications={false}
              showPageRail={pageRailMeta != null}
              stack
            />
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
